module.exports = __webpack_public_path__ + "public/media/ic_right_arrow_blue.c05bf699.svg";